import ActionableMessageCardStrings from '../store/schema/ActionableMessageCardStrings';
import {
    ValidationResults,
    Input,
    ValidationError,
    IValidationError,
    setProperty,
    getBoolValue,
    getStringValue,
} from 'adaptivecards';
import { ITextField, TextField } from '@fluentui/react/lib/TextField';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import styles from '../styles/cardStyles.scss';

export default class CustomTextInput extends Input {
    private textField: ITextField;
    private textFieldElement: HTMLDivElement;

    public static strings: ActionableMessageCardStrings;

    public isMultiline: boolean;
    public placeholder: string;
    public isRequired: boolean = false;
    public maxLength: number;

    private setTextFieldRef = ref => {
        this.textField = ref;
    };
    private textNotValid = (value: string) => {
        return this.isRequired && value === '';
    };

    private validateText = (value: string): string => {
        if (this.textNotValid(value)) {
            return CustomTextInput.strings.warning.requiredField;
        }
        return '';
    };

    private getMaxLength = (maxLenValue): number => {
        let maxLen: number;
        if (maxLenValue === undefined || this.defaultValue === undefined) {
            return maxLen;
        }
        maxLen = Math.max(maxLenValue, this.defaultValue.length);
        return maxLen;
    };

    protected internalRender(): HTMLElement {
        this.textFieldElement = document.createElement('div');
        this.textFieldElement.className = styles.inputElementWrapper;
        const placeholderValue = this.placeholder || CustomTextInput.strings.placeholder.textInput;

        ReactDOM.render(
            <React.StrictMode>
                <TextField
                    required={this.isRequired}
                    componentRef={this.setTextFieldRef}
                    maxLength={this.maxLength}
                    placeholder={placeholderValue}
                    multiline={this.isMultiline}
                    onGetErrorMessage={this.validateText}
                    defaultValue={this.defaultValue}
                    title={placeholderValue}
                />
            </React.StrictMode>,
            this.textFieldElement
        );

        return this.textFieldElement;
    }

    public toJSON(): any {
        let result = super.toJSON();
        setProperty(result, 'placeholder', this.placeholder);
        setProperty(result, 'maxLength', this.maxLength, 0);
        setProperty(result, 'isMultiline', this.isMultiline, false);
        setProperty(result, 'isRequired', this.isRequired, false);
        return result;
    }

    public parse(json: any, errors?: Array<IValidationError>) {
        super.parse(json, errors);
        this.maxLength = this.getMaxLength(json['maxLength']);
        this.isMultiline = getBoolValue(json['isMultiline'], this.isMultiline);
        this.placeholder = getStringValue(json['placeholder']);
        this.isRequired = getBoolValue(json['isRequired'], this.isRequired);
    }

    public remove(): boolean {
        if (this.textFieldElement) {
            ReactDOM.unmountComponentAtNode(this.textFieldElement);
            this.textFieldElement = null;
        }

        return super.remove();
    }

    public internalValidateProperties(context: ValidationResults) {
        if (this.textNotValid(this.value)) {
            context.addFailure(this, {
                error: ValidationError.InvalidPropertyValue,
                message: CustomTextInput.strings.warning.missingRequiredInput,
            });
        }
        return [];
    }

    public getJsonTypeName(): string {
        return 'Input.Text';
    }

    get value(): string {
        return this.textField ? this.textField.value : '';
    }
}
